import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, Tooltip } from '@mui/material';
import CostCard from 'app/pages/Project/ProductionManagement/Dashboards/Widgets/CostCard/CostCard';
import classes from 'app/pages/Project/ProductionManagement/Dashboards/Widgets/CostsWidget/styles.scss';
import FontIcon from 'app/components/FontIcon/FontIcon.jsx';
const EpisodeCostCard = ({ projectId, episodeId, episodeName, episodeData }) => {
    const cardContent = (episodeData) => {
        if (!episodeData)
            return;
        const data = Object.values(episodeData);
        const noData = data.every((el) => { var _a; return !el.deadline && ((_a = el.status_counts) === null || _a === void 0 ? void 0 : _a.length) === 0; });
        if (noData)
            return _jsx("p", { children: "No data provided" });
        const getCostSumByKey = (key1, key2) => data.reduce((acc, val) => acc + val[key1][key2], 0);
        const allStepsClosedCosts = {
            sumActivitiesDuration: getCostSumByKey('closedCosts', 'sumActivitiesDuration'),
            sumQuoteEstimLength: getCostSumByKey('closedCosts', 'sumQuoteEstimLength'),
            sumRealEstimLength: getCostSumByKey('closedCosts', 'sumRealEstimLength'),
        };
        const allStepsTotalCosts = {
            sumQuoteEstimLength: getCostSumByKey('totalCosts', 'sumQuoteEstimLength'),
            sumRealEstimLength: getCostSumByKey('totalCosts', 'sumRealEstimLength'),
        };
        return (_jsx(CostCard, { statusCounts: data[0].status_counts, closedCosts: allStepsClosedCosts, totalCosts: allStepsTotalCosts }));
    };
    return (_jsxs(Card, { className: classes.card, "data-testid": "cost-card", children: [_jsx(CardHeader, { className: classes.cardHeader, title: _jsxs("div", { className: classes.cardTitleContainer, children: [_jsx("div", { className: classes.textContainer, children: _jsx("p", { children: episodeName }) }), _jsx("div", { className: classes.linkToEpisode, children: _jsx(Tooltip, { title: "Go to episode", children: _jsx(Link, { to: `/projects/${projectId}/follow-up/${episodeId}`, children: _jsx(FontIcon, { icon: "fas-external-link-alt", style: { fontSize: 14, padding: '5px', display: 'block' } }) }) }) })] }) }), _jsx(CardContent, { children: cardContent(episodeData) })] }, episodeId));
};
export default EpisodeCostCard;
